import { SEOHead } from "@/components/helpers/seo/SEOHead";
import { Nav } from "@/components/nav/Nav";
import { Authenticate } from "@/components/pages_logged_in/Authenticate";
import { Certifications } from "@/components/pages_logged_in/certifications/Certifications";

export function CertificationsPage() {
  return (
    <Authenticate
      className="h-screen"
      maxWidth="100%"
      layout="dashboard"
      requireWorkspaceAdmin
    >
      <SEOHead title="Certifications – Exec" />
      <Nav />
      <Certifications />
    </Authenticate>
  );
}
